export const impactStats = [
  { value: 250, suffix: "+", label: "Innovation Projects Conducted" },
  { value: 80, suffix: "+", label: "Factories Engaged" },
  { value: 110, suffix: "+", label: "Projects Published" },
  { value: 150, suffix: "+", label: "Experts Connected" },
];

export const sinceYear = "Since 2018 through Textile Today Innovation Hub";

export const associationPartners = [
  {
    name: "Institute of Textile Engineers & Technologists",
    shortName: "ITET",
    partnerType: "Collaboration",
    logo: "/assets/images/logo/itet.jpg",
    focus: [
      "Textile Innovation Expo",
      "International Research Conference",
      "Masterclasses & Technical Training",
      "Peer-Reviewed International Journal",
    ],
  },
  {
    name: "Bangladesh Knitwear Manufacturers and Exporters Association",
    shortName: "BKMEA",
    partnerType: "Association",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/c15a45f9-3495-49da-863f-fac691f4c808_bkmea.jpg?v=e545b0c9c12c545f6f5ef88c1625f206",
    focus: [
      "Training, Innovation mindset diffusion",
      "Factory competitiveness",
      "Sector-wide innovation culture"
    ],
  },
  {
    name: "Bangladesh Garment Buying House Association",
    shortName: "BGBA",
    partnerType: "Association",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/cb5acefa-3d18-4539-9ff3-7670b291718e_bgba.png?v=83fae36c6dda55c5fda11d680afdd9a0",
    focus: [
      "Sourcing innovation",
      "Buying house modernization",
      "Professional training",
      "Factory-buyer-market linkage",
    ],
  },
];

export const factoryPiicPartners = [
  {
    name: "APS Knit Composit Ltd",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/bf1425a2-b840-4578-80c9-7695633e547a_APS-Group.png?v=9965ab5d9e0bfd1560dcaf4ea505e2a4",
  },
  {
    name: "Arien Knit Composite",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/d4d255ad-1789-483a-aa93-e4e562861e54_Arien-Knit-Composite-Ltd..jpg?v=7c013612912b9d1fe42ae6b720fa9d72",
  },
  {
    name: "AukoTex Group",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/cef97174-aa43-4d6d-9a6f-2131b3a13f3b_Aukto-Tex-Group.jpg?v=b9b659ee9abcaa278fb6d0b6a00563ca",
  },
  {
    name: "Centro Tex Ltd.",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/9b5608ab-a95e-436a-b92a-4350653d7568_Centro-Tex-Ltd..png?v=31806dd24c5bf64e2519c0b8eb0eeba2",
  },
  {
    name: "Esquire Group",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/9e618bbb-ec7c-4a4c-bf32-b76885f25d93_Esquire-Group.png?v=258a59436698a629716e26ccaf63bf07",
  },
  {
    name: "Essential Clothing Ltd",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/d502bad4-e07b-46c0-bf11-951e1af03951_Essential-Clothing-Ltd.jpg?v=28215ce7888bccc1aff829e5a5f06ede",
  },
  {
    name: "Fashion Power Group",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/5b9731ca-9887-4562-80d7-40e4e037373e_Fahsion-Power.png?v=afdd3c34e3a2bd8378145532f73bdbed",
  },
  {
    name: "Fatullah Apparels Ltd.",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/04cb682c-52a5-4b33-9b67-e79c3b2ee60a_Fatullah-Apparels.jpg?v=1e0163827662bf73004a038ee90f3d8c",
  },
  {
    name: "HAMS Group",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/43da808f-1a0a-4851-90fb-c8e816268b6c_HAMS-Group.png?v=42b1b4ba92895eda0a9c422c93e0bc88",
  },
  {
    name: "MB Knit Fashion Ltd.",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/c97646ea-33e8-41d8-a83b-71d429d8f7ec_MB-Knit.png?v=e5ef7c8c935bc66da90ce9d02655c511",
  },
  {
    name: "Micro Fibre Group",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/a4449c9f-e05b-459c-aa4e-c41f3a7e9727_Micro-fibre-Group.png?v=648075126a1860a87e169e63664d8d77",
  },
  {
    name: "Mondol Group",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/8f96b299-6156-4338-b81e-3186aa661c20_Mondol-Group.png?v=e2c05133e7e9b90de0b4a794f73d2af5",
  },
  {
    name: "Salma Group",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/b3b82544-837a-429a-8209-ecb889d5021b_Salma-Group-Logo-Final-01-300x117.png?v=d311ad87d7a099fdfb9220b7216caac5",
  },
  {
    name: "South West Composite Ltd.",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/e418e481-d086-4569-90ab-385ac9958f55_South-West-Composite-Ltd..png?v=5b1e4d81ccbfeef9e71c9a8abf7c7b13",
  },
];

export interface TechPartnerTier {
  name: string;
  logo?: string;
  tier: "Platinum" | "Diamond" | "Gold";
}

export const technologyPartners: TechPartnerTier[] = [
  {
    name: "Tanatex Chemicals",
    logo: "/assets/images/logo/tanatex.png",
    tier: "Platinum",
  },
  {
    name: "RH Corporations",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/b5fdbacd-1ad4-4854-9f07-dc901b354dad_RH-Corporation.png?v=934985e3be1c54457ff2054599fb3289",
    tier: "Platinum",
  },
  {
    name: "Raas Biotech",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/e555cd0e-7717-4dff-bbdc-c92ee3e15f9c_Raas-Biotech.jpg?v=fd607d13a0a1153c41b0b2b144b85781",
    tier: "Diamond",
  },
  {
    name: "Aux & Hue Pvt. Limited",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/0d2eceb1-a9d5-4712-9e99-c605f62236dd_Aux--Hue.png?v=861d5002b29fe66fbdaa7718e18cf2d7",
    tier: "Diamond",
  },
  {
    name: "Denim Solutions Ltd.",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/e7ab8ef1-58a6-4ad1-b0cf-f0d3cd34b8e5_Denim-Solutions.png?v=fb98a527a70ba6a22a2990e4938fcbd9",
    tier: "Gold",
  },
  {
    name: "iDES",
    logo: "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/d36286a2-8723-4a2c-9f9c-726f58fc62ed_ides-logo.png?v=62cd5c9050b4fc342820e62a91f61a3f",
    tier: "Gold",
  },
];

export const strategicPartners = factoryPiicPartners;

export const innovationCells = [
  {
    name: "Textile Engineering Cell",
    focus: [
      "Machine optimization & process engineering",
      "Automation feasibility studies",
      "Technical specification development",
      "Engineering-driven efficiency gains",
    ],
  },
  {
    name: "Management Excellence Cell",
    focus: [
      "Organizational transformation & change discipline",
      "Performance management frameworks",
      "Decision routines & governance",
      "Leadership capacity for innovation",
    ],
  },
  {
    name: "Textile Processing Cell",
    focus: [
      "Dyeing & finishing process optimization",
      "Water, steam & energy reduction",
      "Quality stability & RFT improvement",
      "Sustainable processing innovation",
    ],
  },
  {
    name: "Textile Materials Cell",
    focus: [
      "New fiber & yarn development",
      "Blended & technical textile materials",
      "Pre-consumer waste recycling",
      "Material diversification & MMF transition",
    ],
  },
  {
    name: "Marketing & Merchandising Cell",
    focus: [
      "Supply chain operation synchronization",
      "Costing standardization & value engineering",
      "Buyer evaluation & market intelligence",
      "Product positioning for global markets",
    ],
  },
  {
    name: "Textile Efficiency Cell",
    focus: [
      "Lean management & waste elimination",
      "Resource efficiency optimization",
      "Lead-time compression & flow optimization",
      "Preventive maintenance & planning discipline",
    ],
  },
];

export const programmes = [
  {
    wing: "Innovation Wing",
    items: [
      {
        name: "PIIC",
        fullName: "Partnership for Implementation of Innovation Circles",
        description:
          "4-month factory-embedded innovation operating system with 2-4 Innovation Circles, 6-member teams, and comprehensive evidence packs per factory.",
      },
      {
        name: "PTIM",
        fullName: "Practically Tested Innovation Model",
        description:
          "Structured test-before-scale model validating innovations under real production conditions, bridging PIIC outcomes to full implementation.",
      },
      {
        name: "Training",
        fullName: "FSD / PSD / Innovation Black Belt",
        description:
          "Three-tier certification: Factory Skills Development, Professional Skills Development, and Innovation Black Belt - 256+ hours of structured learning.",
      },
      {
        name: "TIE Experts' Platform",
        fullName: "TIE Experts' Platform & Turn-key Consultancy",
        description:
          "Connecting 150+ seasoned experts to factories for specialized guidance, turn-key projects, and peer-to-peer learning networks.",
      },
    ],
  },
  {
    wing: "Research Wing",
    items: [
      {
        name: "PIARC",
        fullName: "Partnership for Implementation of Applied Research Circles",
        description:
          "Applied research circles that generate implementable solutions to real factory problems through evidence-led investigation.",
      },
      {
        name: "IJTAI",
        fullName: "International Journal of Textile & Apparel Innovation",
        description:
          "Bi-annual peer-reviewed journal publishing validated research findings, case studies, and industry benchmarks from Bangladesh and beyond.",
      },
      {
        name: "AIRCon",
        fullName: "Annual International Research Conference",
        description:
          "Annual research conference (January) distributing knowledge, presenting breakthrough findings, and establishing sector research priorities.",
      },
    ],
  },
  {
    wing: "Readiness & Recognition",
    items: [
      {
        name: "ICSRI",
        fullName: "Innovation, Compliance & Sustainability Readiness Index",
        description:
          "Quarterly readiness scoring system benchmarking innovation, compliance, and sustainability capabilities across 11 project areas with 18+ FSD and 32+ PSD indicators.",
      },
      {
        name: "Textile Innovation Awards",
        fullName: "Textile Innovation Awards",
        description:
          "Evidence-based recognition requiring baseline and endline proof. Narratives without verified data do not qualify - credibility is protected.",
      },
    ],
  },
  {
    wing: "Expo Wing",
    items: [
      {
        name: "Textile Innovation Expo",
        fullName: "Textile Innovation Expo 2026",
        description:
          "12-14 November 2026, ICCB Dhaka. Curated marketplace for innovations, solutions, and matchmaking across factories, buyers, and solution providers.",
      },
    ],
  },
];

export const innovationPathway = [
  {
    step: "PIIC",
    title: "Partnership for Implementation of Innovation Circles",
    description:
      "Training enables IC to select problem, establish baseline, run pilot, validate endline, build risk matrix, and draft SOP guidelines. Early wins and execution habit formation.",
    duration: "4 months",
  },
  {
    step: "PTIM",
    title: "Practically Tested Innovation Model",
    description:
      "Test-before-scale for high-risk interventions. Verify cause-effect relationships under production conditions. Prevents superficial rollouts and ensures robust, repeatable solutions.",
    duration: "2-3 months",
  },
  {
    step: "Implementation & Scale-up",
    title: "Scale-up Across Operations",
    description:
      "Management approval to integrate validated innovations into SOP. Execute in line/process and extend to whole floor or factory. Changes embedded in daily operations.",
    duration: "Ongoing",
  },
  {
    step: "Sustain",
    title: "Sustained Innovation System",
    description:
      "Innovation Help Desk follow-up, knowledge repository access, and institutionalized capability. Sustained changes embedded across the organization with quarterly governance.",
    duration: "Continuous",
  },
];

export const researchPrograms = [
  {
    name: "PIARC",
    fullName: "Partnership for Implementation of Applied Research Circles",
    description:
      "PIARC converts factory challenges and data into validated applied solutions. From dyeing efficiency to automation feasibility, it bridges academic knowledge with factory floor reality through evidence-led research circles.",
    areas: [
      "Process optimization",
      "Automation research",
      "Sustainability studies",
      "Material innovation",
    ],
  },
  {
    name: "IJTAI",
    fullName: "International Journal of Textile & Apparel Innovation",
    description:
      "A bi-annual peer-reviewed research publication platform documenting innovation case studies, research findings, and industry best practices from Bangladesh and beyond.",
    areas: [
      "Case studies",
      "Research papers",
      "Industry reports",
      "Best practice documentation",
    ],
  },
  {
    name: "AIRCon",
    fullName: "Annual International Research Conference",
    description:
      "Annual gathering (January) of researchers, factory leaders, and technology providers sharing breakthrough findings, establishing research priorities, and distributing knowledge across the sector.",
    areas: [
      "Annual conference",
      "Research presentations",
      "Panel discussions",
      "Networking",
    ],
  },
];

export const recognitionPrograms = [
  {
    name: "ICSRI",
    fullName: "Innovation, Compliance & Sustainability Readiness Index",
    description:
      "Quarterly readiness scoring assessing factory innovation capability across 11 project areas, 18+ FSD metrics, 32+ PSD indicators, and 256 hours of structured training benchmarks.",
    metrics: [
      { label: "Project Areas", value: "11" },
      { label: "FSD Metrics", value: "18+" },
      { label: "PSD Indicators", value: "32+" },
      { label: "Training Hours", value: "256" },
    ],
  },
  {
    name: "Textile Innovation Awards",
    fullName: "Evidence-Based Recognition",
    description:
      "Rigorous recognition requiring baseline and endline proof with third-party validation. Three evidence-based awards: Best Innovation Circle, Best IC Fellow Member, and Best IC Supervisor/Leader.",
    metrics: [
      { label: "Evidence Required", value: "Baseline/Endline" },
      { label: "Validation", value: "Third-party" },
      { label: "Award Categories", value: "3" },
      { label: "Frequency", value: "Annual" },
    ],
  },
];

export const expoDetails = {
  name: "Textile Innovation Expo 2026",
  date: "12-14 November 2026",
  location: "ICCB, Dhaka, Bangladesh",
  description:
    "The premier curated marketplace for textile innovation, matchmaking, technology adoption, and collaboration. Where solution providers meet factory decision-makers and buyers discover next-generation capabilities.",
  concurrentExpos: [
    {
      name: "Dyeing & Printing Innovation Expo",
      focus: "Sustainable dyeing, digital printing, color management",
    },
    {
      name: "Textile Materials Innovation Expo",
      focus: "New fibers, smart textiles, MMF, sustainable materials",
    },
    {
      name: "Garments Automation & Innovation Expo",
      focus: "Sewing automation, robotics, AI in manufacturing",
    },
    {
      name: "Green and Sustech Expo",
      focus: "Carbon reduction, water recycling, energy efficiency, ESG",
    },
  ],
};

export const steeringBoard = [
  {
    name: "Engr. Ehsanul Karim Kaiser",
    title: "Chairman, Steering Board",
    company:
      "Convener, ITET & Executive Chairman, Textile Today Innovation Hub",
    isLeadership: true,
    image:
      "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/9d2b1a31-28e9-40dd-aaff-6f9e99d18a2a_Engr.-Ehsanul-Karim-Kaiser.png?v=75de500fb11a47b9470485f043f2ceb2",
  },
  {
    name: "Engr. A.S.M Tareq Amin",
    title: "Member Secretary, Steering Board",
    company: "Founder & CEO, Textile Today Innovation Hub",
    isLeadership: true,
    image:
      "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/8bb0bc61-92c3-495f-8477-dcf1c85026ea_Engr.-ASM-Tareq-Amin.png?v=5dca4f961db4c131dcc0d7244732321d",
  },
  {
    name: "Prof. Dr. Engr. Ayub Nabi Khan",
    title: "Vice Chancellor",
    company: "BGMEA University of Fashion & Technology",
    image:
      "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/0104e8c4-55a3-4d1b-bc6d-d9a636dcb86a_Prof.-Dr.-Engr.-Ayub-Nabi-Khan.png?v=3699995751c2a54e9e5b9156aa5ade11",
  },
  {
    name: "Dr. Md. Hasib Uddin",
    title: "Director, BGMEA",
    company: "Managing Director, APS Knit Composite Ltd.",
    image:
      "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/9efea1ab-10c6-456d-8616-4a79c37b419f_Dr.-Md.-Hasib-Uddin.png?v=362d1abca666c515657f087f248aaa0b",
  },
  {
    name: "Engr. Md. Shamsuzzaman",
    title: "Vice President, BKMEA",
    company: "MD, Micro Fibre Group",
    image:
      "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/4884d854-0a73-4f9d-921e-86c08b980c27_Engr.-Md.-Shamsuzzaman.png?v=a5cf6c7ff7fc2909c91692e4446be89a",
  },
  {
    name: "Engr. ATM Mahbubul Alam Milton",
    title: "Executive Director",
    company: "Masco Group",
    image:
      "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/3caa5e01-de1d-4b2a-90a7-33e0876b67a7_Engr.-ATM-Mahbubul-Alam.png?v=c17b9c0b15ba0444899f8c9d732c4cc4",
  },
  {
    name: "Engr. A.S.M Hafizur Rahman Nixon",
    title: "Executive Director",
    company: "RH Corporation (Aziz Group)",
    image:
      "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/a1a530ed-361a-4463-89e5-761e6727bcff_Engr.-Hafizur-Rahman-Nixon.png?v=076452e6df29e2bb47e8a0d10807b30a",
  },
  {
    name: "Md. Azhar Ali",
    title: "Chief Operating Officer",
    company: "Salma Group",
    image:
      "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/59ac1763-ea1e-47ca-a0d0-a6038ad20d2e_Engr.-Md.-Azhar-Ali.png?v=60c08dc924e43935bd75380ba6878c28",
  },
  {
    name: "Engr. Saiful Islam Khan",
    title: "Managing Director",
    company: "Essential Clothing Ltd",
    image:
      "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/b630db3b-ae64-46c8-ad61-6b101437d923_Engr.-Saiful-Islam-Khan.png?v=e7e0aaead8322167922f026269d39199",
  },
  {
    name: "Engr. Shafiur Rahman",
    title: "Country Manager",
    company: "G-Star Raw",
    image:
      "https://storage.readdy-site.link/project_files/3ad77496-7e33-4bee-aed3-853667869f76/b64a01e6-f4bf-439d-a406-9459075f52e5_Engr.-Shafiur-Rahman.png?v=c57e394f528be74cb0a6d6b769c3a718",
  },
];

export const secretariatTeam = [
  {
    role: "Strategic & Reporting Lead",
    name: "Mr. Enamul Hafiz Latifee",
    contact: "pr@textileinnovationexchange.com",
    image: "/assets/images/person/hafiz.jpg",
  },
  {
    role: "Communication & Management Lead",
    name: "Engr. Rahbar Hossain",
    contact: "pr@textileinnovationexchange.com",
    image: "/assets/images/person/rahbar.jpeg",
  },
];

export const navLinks = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Programs", href: "/programs" },
  { label: "Expo", href: "https://www.textileinnovationexpo.com/" },
  { label: "Collaborate", href: "/collaborate" },
  { label: "Contact", href: "/contact" },
];

export const contactInfo = {
  address: "47, Road 3, Sector 13, Uttara, Dhaka, Bangladesh",
  phone: "+880 1717-190567",
  email: "info@textileinnovationexchange.com",
  partnershipEmail: "sales@textileinnovationexchange.com",
};

export const footerLinks = {
  quickLinks: [
    { label: "About", href: "/about" },
    { label: "Media", href: "/media" },
    { label: "Press Release", href: "/press-release" },
    { label: "Sitemap", href: "/sitemap" },
    { label: "Privacy Policy", href: "/privacy-policy" },
    { label: "Terms & Conditions", href: "/terms-conditions" },
  ],
  resources: [
    {
      label: "Textile Innovation Expo",
      href: "https://www.textileinnovationexpo.com/",
    },
    { label: "Collaborate with TIE", href: "/collaborate" },
    { label: "Innovation Cells", href: "/cells/textile-engineering" },
    { label: "PTIM", href: "/ptim" },
    { label: "Ecosystem", href: "/ecosystem" },
  ],
  social: [
    {
      label: "LinkedIn",
      href: "https://www.linkedin.com/company/textile-innovation-exchange/",
      icon: "ri-linkedin-fill",
    },
    {
      label: "Facebook",
      href: "https://www.facebook.com/profile.php?id=61588051634263",
      icon: "ri-facebook-fill",
    },
    // { label: "Twitter", href: "#", icon: "ri-twitter-x-fill" },
    // { label: "YouTube", href: "#", icon: "ri-youtube-fill" },
  ],
};
